export default class FilterListController {
  constructor($scope, FactQuery, Trees, AnalyticsServ) {
    this.scope = $scope;
    this.trees = Trees;
    this.collapsed = {};
    this.factQuery = FactQuery;
    this.analytics = AnalyticsServ;

    this.factQuery.subscribe(() => {
      this.updateFilterLists()
    })
  }
  toggleCollapsed(attr) {
    if (this.factQuery.data.filterPipeline
      .filter(f => !this.collapsed[f.attribute])
      .length === 1 && !this.collapsed[attr]) {
      // Prevent last filter collapse
      return;
    }
    this.collapsed[attr] = !this.collapsed[attr];
    this.computeFilterHeight();
  }
  setFilterLists() {
    let pipeline = this.factQuery.data.filterPipeline
    this.filterTrees = pipeline && pipeline.filter(f => f.attribute !==
      'keywords')
    this.keywordFilter = pipeline && pipeline.filter(f => f.attribute ===
      'keywords')[0]
    this.enableFilterTreeRemoval = pipeline && this.filterTrees.length > 1

  }
  setAvailableAttrs() {
    if (!(this.filterTrees && this.filterTrees.length)) {
      return;
    }
    let viewBy = this.filterTrees[0].attribute;
    let viewByColumns = this.trees[viewBy].grouping.columnsByGroup.map(col =>
      col.key);
    let trees = Object.keys(this.trees);
    let attrs = this.factQuery.data.filterPipeline.map(filter => filter.attribute)
    this.availableAttrs = viewByColumns
      .filter((attr) => {
        return trees.indexOf(attr) !== -1 && attrs.indexOf(attr) === -1
      })
  }
  computeFilterHeight(filterListHeight) {
    this.scope.filterListHeight = filterListHeight || this.scope.filterListHeight;
    let filterPipeline = this.factQuery.data.filterPipeline;
    if (!filterPipeline) {
      return;
    }
    var expandedFilters = filterPipeline
      .filter(f => !this.collapsed[f.attribute])
      .length;
    expandedFilters = expandedFilters === 1 ? 1.5 : expandedFilters;
    let collapsedFilterHeight = 43;
    let viewByOffset = 16;
    let expandedFilterOffset = 39;

    this.selectionListHeight =
      `${(this.scope.filterListHeight - viewByOffset - collapsedFilterHeight - 
                                    (filterPipeline.length * collapsedFilterHeight) - 
                                    (expandedFilters * expandedFilterOffset)) / expandedFilters}px`
  }

  addFilter(attr) {
    if (this.factQuery.data.filterPipeline.length >= 6) {
      return;
    }

    this.factQuery.data.filterPipeline.push({
      "attribute": attr
    });
    this.updateFilterLists()
    this.factQuery.api.update().then(() => {
      this.analytics.added('Filter', {
        'Filter Attribute': attr,
        'View By Attribute': this.factQuery.data.filterPipeline[0].attribute,
        'Filter Count': this.factQuery.data.filterPipeline.length - 1
      });
    });
  }
  updateFilterLists() {
    this.setFilterLists()
    this.setAvailableAttrs()
    this.computeFilterHeight()
  }
  getIndex(attr) {
    return this.factQuery.data.filterPipeline
      .map(f => f.attribute).indexOf(attr)
  }
  removeFilter(attr) {
    // ensure one tree filter is always set
    if (attr !== 'keywords' && !this.enableFilterTreeRemoval) {
      return;
    }
    let index = this.getIndex(attr)
    this.factQuery.data.filterPipeline.splice(index, 1);

    this.updateFilterLists()

    this.factQuery.api.update().then(() => {
      this.analytics.removed('Filter');
    });;
  }

};

FilterListController.$inject = [
  '$scope', 'FactQuery', 'Trees', 'AnalyticsServ'
];



// WEBPACK FOOTER //
// ./project/directives/lf-filter-list/filter-list.controller.js